module.exports = __webpack_public_path__ + "static/media/farm.119bcbbb.svg";